import { useState, useRef, forwardRef, useImperativeHandle } from "react";
import "./DragAndDropList.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";

interface Props {
  arrayOfOptions: Array<any>;
  onListOrdenChange: (copyListItems: Array<any>) => void;
  changeObjectCheckedValue: (label: string) => void;
  labelKey: string;
  checkedKey: string;
}

const DragAndDropList = forwardRef(
  (
    {
      arrayOfOptions,
      onListOrdenChange,
      changeObjectCheckedValue,
      labelKey,
      checkedKey,
    }: Props,
    Ref
  ) => {
    useImperativeHandle(Ref, () => ({}));

    const dragItem: any = useRef();
    const dragOverItem: any = useRef();
    const [list, setList] = useState([...arrayOfOptions]);
    const [dragOver, setDragOver] = useState(null);

    const dragStart = (e: any, position: any) => {
      dragItem.current = position;
    };

    const dragEnter = (e: any, position: any) => {
      dragOverItem.current = position;
      setDragOver(position);
    };

    const drop = (e: any) => {
      const copyListItems = [...list];
      const dragItemContent = copyListItems[dragItem.current];
      copyListItems.splice(dragItem.current, 1);
      copyListItems.splice(dragOverItem.current, 0, dragItemContent);
      dragItem.current = null;
      dragOverItem.current = null;
      onListOrdenChange(copyListItems);
      setList(copyListItems);
      setDragOver(null);
    };

    return (
      <>
        {list &&
          list.map((item, index) => (
            <div
              className={
                dragOver === index ? "dropableRowHover" : "dropableRow"
              }
              onDragStart={(e) => dragStart(e, index)}
              onDragEnter={(e) => dragEnter(e, index)}
              onDragEnd={drop}
              key={index}
              draggable
            >
              {dragOver === index ? (
                "Drop here"
              ) : (
                <>
                <div>
                  {item[labelKey]}
                  <input
                    className="customFieldsModalInput"
                    type="checkbox"
                    checked={!item[checkedKey]}
                    onChange={() => changeObjectCheckedValue(item[labelKey])}
                  />
                </div>
                  <FontAwesomeIcon icon={faGripVertical} />
                </>
              )}
            </div>
          ))}
      </>
    );
  }
);

export default DragAndDropList;
